import api from "../../../api";
import axios from "axios";
import { PUBLIC_SERVICE_URL, SECURITY_TOKEN_FORM } from "../../../config/env";
import { getSetting } from "modules/dashboards/actionables/api";

export function fetchAllProducts() {
  return api.get("product_mapping");
}

export function fetchProductDetails(productId) {
  return axios.get(
    `${PUBLIC_SERVICE_URL}productContentV2/${productId}?language=english`,
    {
      headers: {
        Authorization: `Bearer ${SECURITY_TOKEN_FORM}`,
      },
    }
  );
}

export { getSetting as fetchSettingByKey };
